// Aktivitätsprotokoll der Superadmins (Dialog „Aktivität“ in der Benutzerverwaltung): Anmeldungen und Aktionen aller Personen
// über alle Kunden und Projekte. Der Klartext der Aktionen kommt vom Server (Aktivitaet.Beschreibung, wie protokoll.ts).
import type { Kunde } from './api';
import type { Option } from './ui/fields';

export interface Aktivitaetseintrag {
  art: 'anmeldung' | 'aktion'; nr: number; am: string; email: string; name: string | null;
  kundeId: string | null; kunde: string | null; projektId: string | null; projekt: string | null;
  aktion: string; methode: string | null; pfad: string | null; was: string | null;
}
export interface AktivitaetAntwort { eintraege: Aktivitaetseintrag[]; mehr: boolean }
/** Tage als JJJJ-MM-TT (deutsche Zeit), „bis“ einschließlich. */
export interface AktivitaetFilter { email?: string; kunde?: string; projekt?: string; von?: string; bis?: string }

/** Abfrage für /api/aktivitaet und /api/aktivitaet/export (leere Felder entfallen). */
export function abfrage(f: AktivitaetFilter): string {
  const q = new URLSearchParams();
  for (const k of ['email', 'kunde', 'projekt', 'von', 'bis'] as const) if (f[k]) q.set(k, f[k]!);
  const s = q.toString();
  return s ? '?' + s : '';
}

const z2 = (n: number) => String(n).padStart(2, '0');
/** Tag als JJJJ-MM-TT in lokaler Zeit, „tage“ Tage nach (negativ: vor) heute. */
export function tag(tage = 0, heute = new Date()): string {
  const d = new Date(heute);
  d.setDate(d.getDate() + tage);
  return `${d.getFullYear()}-${z2(d.getMonth() + 1)}-${z2(d.getDate())}`;
}

/** Projekte zur Auswahl: alle oder die des gewählten Kunden, nach Kunde gruppiert. */
export function projektOptionen(kunden: Kunde[], kundeId?: string): Option[] {
  return [{ value: '', label: 'Alle Projekte' }, ...kunden.filter((k) => !kundeId || k.id === kundeId)
    .flatMap((k) => k.projekte.map((p) => ({ value: p.id, label: p.titel, gruppe: k.name })))
    .sort((a, b) => a.gruppe.localeCompare(b.gruppe) || a.label.localeCompare(b.label))];
}

/** Bezug eines Eintrags: Kunde › Projekt (sofern vorhanden). */
export function ort(e: Pick<Aktivitaetseintrag, 'kunde' | 'kundeId' | 'projekt' | 'projektId'>): string {
  return [e.kunde ?? e.kundeId, e.projekt ?? e.projektId].filter(Boolean).join(' › ');
}

/** Dateiname des Excel-Exports (wie der Server ihn vorschlägt). */
export function dateiname(f: AktivitaetFilter): string {
  return 'aktivitaet' + (f.von ? '-ab-' + f.von : '') + (f.bis ? '-bis-' + f.bis : '') + '.xlsx';
}
